import React, { PureComponent } from 'react';
import { translate } from 'react-i18next';
import PropTypes from 'prop-types';
import { Doughnut } from 'react-chartjs-2';

class AssetsDepreciationChart extends PureComponent {
  static propTypes = {
    label: PropTypes.string.isRequired,
    depreciation: PropTypes.number.isRequired,
    depreciable: PropTypes.number.isRequired,
    t: PropTypes.func.isRequired,
  };

  render = () => (
    <Doughnut
      height={120}
      label={this.props.t(this.props.label)}
      data={{
        labels: [this.props.t('assets.depreciation'), this.props.t('assets.depreciable')],
        datasets: [
          {
            backgroundColor: ['#bac3d1', '#33c6d2'],
            borderWidth: 1,
            data: [this.props.depreciation, this.props.depreciable],
          },
        ],
      }}
      options={{
        maintainAspectRatio: false,
      }}
    />
  );
}

export default translate()(AssetsDepreciationChart);



// WEBPACK FOOTER //
// src/components/assets/depreciation/AssetsDepreciationChart.js